import styled from 'styled-components';
import { Body1, Body2, colors, spacing, fontWeights } from 'ui/theme';

export const Body1Light = styled(Body1)`
  color: ${colors.textSecondary};
  font-weight: ${fontWeights.regular};
`;

export const Body2NoMargin = styled(Body2)`
  margin-bottom: 0;
`;

export const Body2Underline = styled(Body2)`
  text-decoration: underline;
  text-decoration-color: ${colors.borderEmphasis};
  text-decoration-style: dashed;
  text-underline-offset: ${spacing.quarter};
`;

export const Body2Light = styled(Body2)`
  color: ${colors.textSecondary};
`;

export const Body2LightNoMargin = styled(Body2)`
  color: ${colors.textSecondary};
  margin-bottom: 0;
`;
